import React, { Component } from 'react'
import PropTypes from 'prop-types'
import LightBoxForm from "./forms/LightBoxForm";
import EmptyForm from "./forms/EmptyForm";
import AkismetForm from "./forms/AkismetForm";
import DaumShowForm from "./forms/DaumShowForm";
import AdfitPCForm from "./forms/AdfitPCForm";
import GoogleAD2015Form from "./forms/GoogleAD2015Form";
import ADForDableForm from "./forms/ADForDableForm";
import PostListinCategoryForm from "./forms/PostListinCategoryForm";
import TatterDeskForm from "./forms/TatterDeskForm";
import CommentCaptchaForm from "./forms/CommentCaptchaForm";
import MapSideBarForm from "./forms/MapSideBarForm";
import Emblem2009Form from "./forms/Emblem2009Form";
import SupportersForm from "./forms/SupportersForm";
import NewYearGoalForm from "./forms/NewYearGoalForm";
import LiveReForm from "./forms/LiveReForm";
import KakaoStoryPlusForm from "./forms/KakaoStoryPlusForm";
import GoogleAdsenseForMobileForm from "./forms/GoogleAdsenseForMobileForm";
import GoogleAdsenseForResponsiveForm from "./forms/GoogleAdsenseForResponsiveForm";
import Tistory2TwitterForm from "./forms/Tistory2TwitterForm";
import WatchTowerForm from "./forms/WatchTowerForm";
import ShareEntryWithSNSForm from "./forms/ShareEntryWithSNSForm";
import TenpingForm from "./forms/TenpingForm";
import AdamForm from "./forms/AdamForm";
import BlogIconForm from "./forms/BlogIconForm";
import EvernoteForm from "./forms/EvernoteForm";
import BusinessLicenseInfoForm from "./forms/BusinessLicenseInfoForm";
import BusinessLicenseInfoForDaumblogForm from "./forms/BusinessLicenseInfoForDaumblogForm";
import AddLinkToPostWithSearchForm from "./forms/AddLinkToPostWithSearchForm";
import InterparkBookSearchForm from "./forms/InterparkBookSearchForm";
import EmoticonOnComment from "./forms/EmoticonOnComment";
import PreventCopyContents from "./forms/PreventCopyContents";
import ExifForm from "./forms/ExifForm";
import GoogleAnalyticsForm from "./forms/GoogleAnalyticsForm";
import NaverAnalyticsForm from "./forms/NaverAnalyticsForm";
import StatGraphForm from "./forms/StatGraphForm";
import YouTubeSearchForm from "./forms/YouTubeSearchForm";
import SyntaxHighlightForm from './forms/SyntaxHighlightForm';
import MetaTagForm from "./forms/MetaTagForm"
import GoogleSearchConsoleForm from "./forms/GoogleSearchConsoleForm"
import {isDaumBlogDomain} from "../../utils/UriUtil";

function PluginDetailForm(props) {
  const { plugin } = props
  switch (plugin.name) {
    case 'GoogleSearchConsole':
      return <GoogleSearchConsoleForm {...props} />
    case 'lightbox':
      return <LightBoxForm {...props} />
    case 'Akismet':
      return <AkismetForm {...props} />
    case 'DaumShow':
      return <DaumShowForm {...props} />
    case 'Adfit_PC':
      return <AdfitPCForm {...props} />
    case 'GoogleAD2015':
      return <GoogleAD2015Form {...props} />
    case 'ADForDable' :
      return <ADForDableForm {...props} />
    case 'PostListinCategory':
      return <PostListinCategoryForm {...props} />
    case 'tatterDesk':
      return <TatterDeskForm {...props} />
    case 'CommentCaptcha':
      return <CommentCaptchaForm {...props} />
    case 'MapSideBar':
      return <MapSideBarForm {...props} />
    case 'Emblem2009':
      return <Emblem2009Form {...props} />
    case 'Supporters2007':
      return <SupportersForm year="thankyou2007" mobile={false} {...props} />
    case 'Supporters2008':
      return <SupportersForm year="thankyou2008" mobile={false} {...props} />
    case 'Supporters2009':
      return <SupportersForm year="thankyou2009" mobile={false} {...props} />
    case 'Supporters2010':
      return <SupportersForm year="thankyou2010" mobile={false} {...props} />
    case 'Supporters2011':
      return <SupportersForm year="thankyou2011" mobile={false} {...props} />
    case 'Supporters2012':
      return <SupportersForm year="thankyou2012" mobile={true} {...props} />
    case 'Supporters2013':
      return <SupportersForm year="thankyou2013" mobile={true} {...props} />
    case 'Supporters2014':
      return <SupportersForm year="thankyou2014" mobile={true} {...props} />
    case 'Supporters2015':
      return <SupportersForm year="thankyou2015" mobile={true} {...props} />
    case 'Supporters2009Triple':
      return <SupportersForm year="bestofbest2009" mobile={false} {...props} />
    case 'A_NewYearGoal':
      return <NewYearGoalForm {...props} />
    case 'LiveRe_v2':
      return <LiveReForm {...props} />
    case 'KakaoStoryPlus':
      return <KakaoStoryPlusForm {...props} />
    case 'Tistory2Twitter':
      return <Tistory2TwitterForm {...props} />
    case 'A_ShareEntryWithSNS':
      return <ShareEntryWithSNSForm {...props} />
    case 'GoogleAdsenseForMobile':
      return <GoogleAdsenseForMobileForm {...props} />
    case 'GoogleAdsenseForResponsive':
      return <GoogleAdsenseForResponsiveForm {...props} />
    case 'AD_Tenping':
      return <TenpingForm {...props} />
    case 'Adam':
      return <AdamForm {...props} />
    case 'BlogIcon':
      return <BlogIconForm {...props} />
    case 'Evernote':
      return <EvernoteForm {...props} />
    case 'BusinessLicenseInfo':
      if (isDaumBlogDomain()) {
        return <BusinessLicenseInfoForDaumblogForm {...props} />
      }
      return <BusinessLicenseInfoForm {...props} />
    case 'AddLinkToPostWithSearch':
      return <AddLinkToPostWithSearchForm {...props} />
    case 'InterparkBookSearch':
      return <InterparkBookSearchForm {...props} />
    case 'EmoticonOnComment':
      return <EmoticonOnComment {...props} />
    case 'PreventCopyContents' :
      return <PreventCopyContents {...props} />
    case 'Exif' :
      return <ExifForm {...props}/>
    case 'GoogleAnalytics' :
      return <GoogleAnalyticsForm {...props}/>
    case 'NaverAnalytics' :
      return <NaverAnalyticsForm {...props}/>
    case 'StatGraph' :
      return <StatGraphForm {...props}/>
    case 'YouTubeSearch' :
      return <YouTubeSearchForm {...props}/>
    case 'WatchTower' :
      return <WatchTowerForm {...props} />
    case 'SyntaxHighlight':
      return <SyntaxHighlightForm {...props} />
    case 'MetaTag':
      return <MetaTagForm {...props}/>
    default:
      return <EmptyForm {...props} />
  }
}

PluginDetailForm.propTypes = {
	plugin: PropTypes.object.isRequired,
	data: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired
}

export default PluginDetailForm
